
@if (!isPayment) {
  <div class="row justify-content-center">
    @if (isWallet) {
      <div class="d-flex justify-content-center">
        <img class="img-fluid" src="images/omsn.webp" alt="orange money" width="110" height="50">
      </div>
    }
    <div class="mt-3 col-5 border rounded">
      <div class="d-flex justify-content-center" style="width: 300;">Scanner et payez </div>
      <div class="d-flex justify-content-center">
        <qrcode [qrdata]="qrCode" [width]="400" [errorCorrectionLevel]="'H'" [colorDark]="'#00ff00ff'"></qrcode>
      </div>
      <div class="d-flex justify-content-center">
        <p class="fs-2 text-cener">{{this.merchant?.name}}</p>
      </div>
      @if (!isWallet) {
        <div class="d-flex justify-content-center">
          <img class="img-fluid" src="images/omsn.webp" alt="orange money" width="100" height="50">
          <img class="img-fluid" src="images/wave-logo.webp" alt="orange money" width="100" height="50">
          <img class="img-fluid" src="images/visamaster.png" alt="orange money" width="100" height="50">
        </div>
      }
    </div>
  </div>
}
@if (isPayment) {
  <div class="payment-container">
    <div id="payment-page" class="payment-page">
      <div class="mb-3">
        <p class="justify-content-center fs-3">{{qrMessage}}</p>
      </div>
      <div class="payment-header">
        <h3></h3>
        <p>Veuillez choisir votre moyen de paiement</p>
      </div>
      <div class="row justify-content-center gap-method">
        <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2 ml-3 p-2"
          style="width: auto;" data-method="card" (click)="onSelectPaymentMethod('card')">
          <img class="img-fluid" src="images/visamaster.png" alt="carte" width="50">
          <p class="mt-2 mb-0 text-center">Carte</p>
        </div>
        <div class="col-3 ml-2 payment-method border rounded d-flex flex-column justify-content-center mb-2"
          style="width: 135px;" data-method="omsn" (click)="onSelectPaymentMethod('omsn')">
          <img class="mt-4 img-fluid justify-content-center" src="images/omsn.webp" alt="orange money" width="50">
          <p class="mt-1 ml-3">Orange money</p>
        </div>
        <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2"
          data-method="wvsn" style="width: auto;" (click)="onSelectPaymentMethod('wvsn')">
          <img class="mt-4 img-fluid justify-content-center" src="images/wave-logo.webp" alt="wave" width="50">
          <p class="mt-1  ml-3">Wave</p>
        </div>
      </div>
      <form [formGroup]="formPay" class="form">
        <div class="row justify-content-center">
          <div class="form-group col-sm-5  mb-2">
            <input type="tel"  placeholder="Montant a payer" class="form-control"
              formControlName="amount">
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="form-group col-sm-5  mb-2">
            @if (isWallet) {
              <input type="tel" placeholder="Numero t&#233;l&#233;phone" class="form-control"
                formControlName="phone">
            }
          </div>
        </div>
      </form>
      @if (isValid()) {
        <div class="d-grid gap-2 col-6 mx-auto">
          <button class="btn btn-success" (click)="initPayment()">Valider</button>
        </div>
      }
    </div>
  </div>
}